import { Directive, Input, OnInit, ElementRef } from '@angular/core';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[m]'
})
export class MarginDirective implements OnInit {
  @Input() m = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const marginKeys = Object.keys(this.m);

      marginKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`m-${this.m[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`m-${key}-${this.m[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed margins\`: ${err}`);
    }
  }
}

@Directive({
  selector: '[mt]'
})
export class MarginTopDirective implements OnInit {
  @Input() mt = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const marginKeys = Object.keys(this.mt);

      marginKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`mt-${this.mt[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`mt-${key}-${this.mt[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed margins\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[mb]'
})
export class MarginBottomDirective implements OnInit {
  @Input() mb = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const marginKeys = Object.keys(this.mb);

      marginKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`mb-${this.mb[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`mb-${key}-${this.mb[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed margins\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[ml]'
})
export class MarginLeftDirective implements OnInit {
  @Input() ml = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const marginKeys = Object.keys(this.ml);

      marginKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`ml-${this.ml[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`ml-${key}-${this.ml[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed margins\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[mr]'
})
export class MarginRightDirective implements OnInit {
  @Input() mr = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const marginKeys = Object.keys(this.mr);

      marginKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`mr-${this.mr[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`mr-${key}-${this.mr[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed margins\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[mx]'
})
export class MarginHorizontalDirective implements OnInit {
  @Input() mx = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const marginKeys = Object.keys(this.mx);

      marginKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`mx-${this.mx[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`mx-${key}-${this.mx[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed margins\`: ${err}`);
    }
  }
}

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[my]'
})
export class MarginVerticalDirective implements OnInit {
  @Input() my = {};

  private elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.elementRef = elementRef;
  }

  ngOnInit() {
    try {
      const marginKeys = Object.keys(this.my);

      marginKeys.forEach(key => {
        if (key === 'all') {
          this.elementRef.nativeElement.classList.add(`my-${this.my[key]}`);
        } else {
          this.elementRef.nativeElement.classList.add(`my-${key}-${this.my[key]}`);
        }
      });
    } catch (err) {
      console.error(`Malformed margins\`: ${err}`);
    }
  }
}
